






























import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class FacebookIcon extends Vue {
  @Prop({ default: '16' }) readonly width?: string;
  @Prop({ default: '16' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly fill?: string;
}
